import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/working_set_specifications/Files.scss';
import * as _ from 'lodash';
import classNames from 'classnames';
import ArrowDownMiddleIcon from '../../assets/images/arrow-down-middle-15x15.svg';
import autobind from 'autobind-decorator';
import {
  __,
  bytesToSize,
  dateFrom,
  mapStateToProps,
  setTableParams,
  timeFrom,
} from '../../core/utils';
import { setNotification } from '../../redux/actions/general/notification';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import {
  readWorkingSetSpecification,
  uploadSpecificationFiles,
} from '../../redux/actions/table/working_set_specifications';
import FilePreview from '../../components/FilePreview';
import ReactDropzone from 'react-dropzone';
import UploadIcon from '../../assets/images/upload-40x40.svg';
import DeleteIcon from '../../assets/images/delete-15x15.svg';
import { Form, getFormValues, reduxForm } from 'redux-form';
import Select from '../../components/Select';
import Images from './Images';
import Avatar from '../../components/Avatar';
import { hideDropdown } from '../../redux/actions/general/dropdown';
import {
  archiveAttachment,
  deleteAttachmentCurrentVersion,
  unarchiveAttachment,
} from '../../redux/actions/attachments';
import AttachmentFileMenu from '../../components/AttachmentFileMenu';
import { setAttachmentParams } from '../../redux/actions/general/attachments';
import Dropdown from '../../components/Dropdown';
import { linkFilesToModel } from '../../redux/actions/table/files';

@reduxForm({
  form: 'working_set_specifications.files',
  enableReinitialize: true,
})
@mapStateToProps((state, props) => ({
  store: state.table.products,
  values: getFormValues('working_set_specifications.files')(state),
  flyout: state.table.working_set_specifications.flyout,
}))
class Files extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: [],
      files: [],
      active_category: null,
      category_errors: null,
      showArchivedFiles: false,
    };
  }

  @autobind
  _toggleCollapseCategory(category) {
    this.setState({
      expanded: _.xor(this.state.expanded, [category]),
    });
  }

  componentDidMount() {
    const { files, images } = this.props.flyout;

    this.setState({
      expanded: _.map([...files, ...images], (file) => file.category),
    });

    window.addEventListener('paste', this._handlePaste);
  }

  componentWillUnmount() {
    window.removeEventListener('paste', this._handlePaste);
  }

  @autobind
  _handlePaste(event) {
    const files = event.clipboardData.files;

    this.setState({
      files: [
        ..._.values(this.state.files),
        ..._.map(files, (file) => {
          return {
            file: Object.assign(file, {
              stream_url: URL.createObjectURL(file),
              ext: file.name.split('.').pop(),
            }),
            category: '',
          };
        }),
      ],
    });

    this.props.change('files', files);
  }

  @autobind
  _uploadFiles(category, files) {
    const specification_id = this.props.flyout.id;
    const stage_id = this.props.flyout.stage_id;
    const uploadedFiles = _.reject(this.state.files, 'linked_attachment');
    const linkedFiles = _.filter(this.state.files, 'linked_attachment');
    const actions = _.compact([
      !_.isEmpty(uploadedFiles) &&
        uploadSpecificationFiles(specification_id, uploadedFiles),
      !_.isEmpty(linkedFiles) &&
        linkFilesToModel(
          stage_id,
          'Specification',
          specification_id,
          _.map(linkedFiles, (row) => ({
            id: row.attachment_id,
            category: row.category,
          }))
        ),
    ]);

    setNotification(
      __('working-set-specifications.files.please-wait-files-uploaded')
    );

    Promise.all(actions)
      .then(() => {
        this.props._refetchData().then((data) => {
          const { files, images } = data;

          this.setState({
            expanded: _.map([...files, ...images], (file) => file.category),
            files: [],
            category_errors: null,
            active_category: null,
          });
        });
      })
      .catch((error) => {
        this.setState({
          category_errors: _.map(
            Object.keys(_.get(error, 'response.errors', {})),
            (key) => _.toNumber(_.first(key.match(/\d+/)))
          ),
        });

        setNotification({
          text: __(
            'working-set-specifications.files.your-files-not-uploaded.duble-check-file-formats-sizes'
          ),
          type: 'warning',
        });
      });
  }

  @autobind
  _downloadFile({ download_url }) {
    setNotification(__('working-set-specifications.files.download.continue'));

    window.open(download_url, '_blank');
  }

  @autobind
  _refreshSpecification() {
    return readWorkingSetSpecification(this.props.flyout.id).then(
      ({ response }) => {
        setTableParams('working_set_specifications', {
          flyout: response.data,
        });

        return response.data;
      }
    );
  }

  @autobind
  _openEditAttachment(row) {
    hideDropdown();

    setAttachmentParams({
      edit_attachment_wizard: row,
      attachment_context: {
        type: 'working_set_specification',
        specification_id: this.props.flyout.id,
      },
    });

  }

  @autobind
  _openUploadAttachmentVersion(row) {
    hideDropdown();

    setAttachmentParams({
      upload_attachment_version_wizard: row,
      attachment_context: {
        type: 'working_set_specification',
        specification_id: this.props.flyout.id,
      },
    });

  }

  @autobind
  _archiveAttachment(row) {
    const is_archived = !!row.archived;
    const update_archive = is_archived
      ? unarchiveAttachment
      : archiveAttachment;

    hideDropdown();

    showAlertbox({
      color: 'blue',
      title: __('general.alert.are-you-sure'),
      description: is_archived
        ? __(
            'attachments.alert.unarchive-file',
            {},
            'Are you sure you want to unarchive this file?'
          )
        : __(
            'attachments.alert.archive-file',
            {},
            'Are you sure you want to archive this file?'
          ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: is_archived
            ? __('attachments.button.unarchive', {}, 'Unarchive')
            : __('attachments.button.archive', {}, 'Archive'),
          onClick: () => {
            update_archive(row.attachment_id).then(() => {
              hideAlertbox();
              setNotification(
                is_archived
                  ? __(
                      'attachments.notification.unarchived',
                      {},
                      'File unarchived.'
                    )
                  : __(
                      'attachments.notification.archived',
                      {},
                      'File archived.'
                    )
              );
              this._refreshSpecification();
            });
          },
        },
      ],
    });
  }

  @autobind
  _deleteFile(row) {
    hideDropdown();

    showAlertbox({
      color: 'red',
      title: __('general.alert.are-you-sure'),
      description: __(
        'working-set-specifications.files.are-you-sure-to-remove-this-file'
      ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: __('general.alert.yes-delete'),
          onClick: () => {
            deleteAttachmentCurrentVersion(row.attachment_id).then(() => {
              hideAlertbox();

              setNotification(
                __('working-set-specifications.files.selected-file-deleted')
              );

              this._refreshSpecification();
            });
          },
        },
      ],
    });
  }

  @autobind
  _handleDrop(acceptedFiles, rejectedFiles) {
    this.setState({ drag: false });

    if (!_.isEmpty(acceptedFiles)) {
      if (_.size(rejectedFiles) > 1) {
        setNotification({
          text: __('specifications.files.upload.bulk-not-allowed'),
          type: 'warning',
        });
      } else if (!_.isEmpty(rejectedFiles)) {
        setNotification({
          text: __('specifications.files.upload.incorrect.format'),
          type: 'warning',
        });
      } else if (
        _.find(acceptedFiles, (file) => {
          return file.size >= 312857600;
        })
      ) {
        setNotification({
          text: __('specifications.files.upload.upload-limit'),
          type: 'warning',
        });
      } else {
        this.setState({
          files: [
            ..._.values(this.state.files),
            ..._.map(acceptedFiles, (file) => {
              return {
                file: Object.assign(file, {
                  stream_url: URL.createObjectURL(file),
                  ext: file.name.split('.').pop(),
                }),
                category: '',
              };
            }),
          ],
        });

        this.props.change('files', acceptedFiles);
      }
    }
  }

  @autobind
  _normalizeLinkedFile(file) {
    return {
      linked_attachment: true,
      attachment_id: file.id,
      category: '',
      file: {
        id: file.id,
        attachment_id: file.id,
        attachment_version_id: file.attachment_version_id,
        stream_url: file.stream_url || file.thumbnail_url,
        download_url: file.download_url,
        name: file.name || file.file_name,
        ext: file.ext || file.extension,
        size: file.size,
        creator: file.creator,
        version: file.version,
        current_version_created_at:
          file.current_version_created_at || file.uploaded_at,
        created_at: file.created_at || file.uploaded_at,
      },
    };
  }

  @autobind
  _openLinkExistingFilesWizard() {
    const { flyout } = this.props;
    const stage_id = flyout.stage_id;

    hideDropdown();
    setAttachmentParams({
      link_existing_files_wizard: {
        stage_id,
        linked_file_ids: [
          ..._.map([...flyout.files, ...flyout.images], 'attachment_id'),
          ..._.map(
            _.filter(this.state.files, 'linked_attachment'),
            'attachment_id'
          ),
        ],
        showSuccessNotification: false,
        onLinkFiles: (file_ids, selectedFiles) => {
          const selectedFileIds = new Set(file_ids);
          const nextFiles = [
            ..._.values(this.state.files),
            ..._.map(
              _.filter(selectedFiles, (file) =>
                selectedFileIds.has(Number(file.id))
              ),
              this._normalizeLinkedFile
            ),
          ];

          this.setState({
            files: _.uniqBy(nextFiles, (row, index) =>
              row.linked_attachment
                ? 'linked_' + row.attachment_id
                : 'uploaded_' + index
            ),
          });

          return Promise.resolve();
        },
      },
    });
  }

  @autobind
  _openUploadPicker() {
    hideDropdown();

    if (this.dropzone) {
      this.dropzone.open();
    }
  }

  render() {
    const { collapsed, flyout, readOnly } = this.props;
    const { expanded, showArchivedFiles } = this.state;
    const allAttachments = [...flyout.files, ...flyout.images];
    const archivedFilesCount = _.size(
      _.filter(allAttachments, (file) => file.archived)
    );
    const visibleAttachments = showArchivedFiles
      ? allAttachments
      : _.filter(allAttachments, (file) => !file.archived);

    const categories = [
      {
        label: __('working-set-specifications.images.thumbnail'),
        value: 'thumbnail',
        category: 'images',
      },
      {
        label: __('working-set-specifications.product'),
        value: 'product',
        category: 'images',
      },
      {
        label: __('working-set-specifications.drawing'),
        value: 'drawing',
        category: 'images',
      },
      {
        label: __('working-set-specifications.ambient'),
        value: 'ambient',
        category: 'images',
      },
      {
        label: __('working-set-specifications.technical'),
        value: 'technical',
        category: 'images',
      },
      {
        label: __('working-set-specifications.tileable-texture-for-3d'),
        value: 'tileable',
        category: 'images',
      },
      {
        label: __('working-set-specifications.files.manuals'),
        value: 'manuals',
        category: 'files',
      },
      {
        label: __('working-set-specifications.files.datasheets'),
        value: 'datasheets',
        category: 'files',
      },
      {
        label: __('working-set-specifications.files.guarantee'),
        value: 'guarantee',
        category: 'files',
      },
      {
        label: __('working-set-specifications.files.certificates'),
        value: 'certificates',
        category: 'files',
      },
      {
        label: __('working-set-specifications.files.catalogs'),
        value: 'catalogs',
        category: 'files',
      },
      {
        label: __('working-set-specifications.files.installation'),
        value: 'installation',
        category: 'files',
      },
      {
        label: __('working-set-specifications.files.bim'),
        value: 'bim',
        category: 'files',
      },
      {
        label: __('working-set-specifications.files.3d'),
        value: '3d',
        category: 'files',
      },
      {
        label: __('working-set-specifications.files.cad'),
        value: 'cad',
        category: 'files',
      },
      {
        label: __('working-set-specifications.files.2d'),
        value: '2d',
        category: 'files',
      },
      {
        label: __('working-set-specifications.files.light-data'),
        value: 'light_data',
        category: 'files',
      },
      {
        label: __('working-set-specifications.files.video'),
        value: 'video',
        category: 'files',
      },
      {
        label: __('working-set-specifications.files.audio'),
        value: 'audio',
        category: 'files',
      },
      {
        label: __('working-set-specifications.files.other'),
        value: 'other',
        category: 'files',
      },
    ];

    const { files, category_errors, active_category } = this.state;

    const lightbox_files = _.map(
      _.filter(files, (row) =>
        _.includes(['jpg', 'jpeg', 'png'], _.toLower(row.file.ext))
      ),
      (row) => ({
        id: row.file.id,
        attachment_version_id: row.file.attachment_version_id,
        stream_url: row.file.stream_url,
        title: [row.file.name, row.file.ext].join('.'),
      })
    );

    return (
      <div
        className={classNames(styles.wrapper, collapsed && styles.collapsed)}
      >
        {!_.isEmpty(allAttachments) && (
          <div className={styles.actions}>
            <label className={styles.showArchivedFiles}>
              {archivedFilesCount > 0 ? (
                <>
                  <span>
                    {__(
                      'working-set-specifications.files.show-hide-archived-files'
                    )}{' '}
                    {'(' + archivedFilesCount + ')'}
                  </span>
                  <input
                    type='checkbox'
                    checked={showArchivedFiles}
                    onChange={(e) =>
                      this.setState({ showArchivedFiles: e.target.checked })
                    }
                  />
                </>
              ) : (
                <span>
                  {__('working-set-specifications.files.no-archived-files')}
                </span>
              )}
            </label>
          </div>
        )}
        {/* Files list */}
        {_.map(categories, (category) => {
          const category_files = _.sortBy(
            _.filter(
              visibleAttachments,
              ['category', category.value]
            ),
            ['order']
          );

          const lightbox_images = _.map(
            _.filter(category_files, (file) =>
              _.includes(['jpg', 'jpeg', 'png', 'pdf'], _.toLower(file.ext))
            ),
            (file) => ({
              id: file.id,
              attachment_version_id: file.attachment_version_id,
              stream_url: file.stream_url,
              title: [file.name, file.ext].join('.'),
              download_url: file.download_url,
              ext: file.ext,
              width: file.width,
              height: file.height,
            })
          );

          return (
            <>
              {!_.isEmpty(category_files) && (
                <div className={styles.category} key={category.value}>
                  <div
                    className={styles.title}
                    onClick={() => this._toggleCollapseCategory(category.value)}
                  >
                    <ArrowDownMiddleIcon
                      className={classNames(
                        styles.collapse,
                        !_.includes(expanded, category.value) &&
                          styles.collapsed
                      )}
                    />
                    {category.label}{' '}
                    {!_.isEmpty(category_files) &&
                      '(' + _.size(category_files) + ')'}
                  </div>
                  {_.includes(expanded, category.value) &&
                    (_.includes(
                      [
                        'thumbnail',
                        'product',
                        'drawing',
                        'ambient',
                        'technical',
                        'tileable',
                      ],
                      category.value
                    ) ? (
                      <Images
                        data={category_files}
                        readOnly={readOnly}
                        category={category.value}
                      />
                    ) : (
                      !_.isEmpty(category_files) && (
                        <div className={styles.files}>
                          {_.map(category_files, (file) => {
                            const can_manage_file =
                              _.isNull(flyout.product_id) || !readOnly;
                            return (
                              <div
                                className={classNames(
                                  styles.file,
                                  file.archived && styles.archived
                                )}
                                key={file.attachment_id || file.id}
                              >
                                <div className={styles.left}>
                                  <FilePreview
                                    onDownloadFile={this._downloadFile}
                                    row={file}
                                    lightbox_images={lightbox_images}
                                  />
                                </div>

                                <div className={styles.right}>
                                  <span className={styles.version}>
                                    {'V' + file.version}
                                  </span>

                                  <span className={styles.size}>
                                    {bytesToSize(file.size)}
                                  </span>

                                  {file.creator && (
                                    <div className={styles.avatar}>
                                      <Avatar
                                        size={24}
                                        {...file.creator}
                                        avatar_url={file.creator.avatar_url}
                                      />
                                    </div>
                                  )}

                                  <div className={styles.date_time}>
                                    {dateFrom(
                                      file.current_version_created_at ||
                                        file.created_at
                                    )}
                                    <br />
                                    {timeFrom(
                                      file.current_version_created_at ||
                                        file.created_at
                                    )}
                                  </div>

                                  <div className={styles.icons}>
                                    <AttachmentFileMenu
                                      name={
                                        'working_set_specification_file_menu_' +
                                        (file.attachment_id || file.id)
                                      }
                                      row={file}
                                      canManageFile={can_manage_file}
                                      canVersionFile={can_manage_file}
                                      onDownloadFile={this._downloadFile}
                                      onOpenEdit={this._openEditAttachment}
                                      onOpenUploadVersion={
                                        this._openUploadAttachmentVersion
                                      }
                                      onArchiveAttachment={
                                        this._archiveAttachment
                                      }
                                      onDeleteFile={this._deleteFile}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )
                    ))}
                </div>
              )}
            </>
          );
        })}

        {/* Dropzone - upload files */}
        {!readOnly && (
          <ReactDropzone
            ref={(dropzone) => {
              this.dropzone = dropzone;
            }}
            className={classNames(
              styles.dropzone,
              _.get(this.state, 'drag') && styles.drag
            )}
            disableClick
            onDrop={this._handleDrop}
            onDragOver={() => this.setState({ drag: true })}
            onDragLeave={() => this.setState({ drag: false })}
            multiple={true}
          >
            <UploadIcon />
            <span className={styles.dropTitle}>
              {__('dropzone.title.drop-your-file-here')}
            </span>
            <Dropdown
              portal
              top={28}
              right={0}
              name={'working_set_specification_add_files_' + flyout.id}
              wrapperClassName={styles.addFilesDropdownWrapper}
              dropdownClassName={styles.addFilesDropdown}
              content={
                <div className={styles.addFilesMenu}>
                  <div
                    className={styles.addFilesOption}
                    onClick={this._openLinkExistingFilesWizard}
                  >
                    {__('working-set-specifications.files.browse-from-volum3')}
                  </div>
                  <div
                    className={styles.addFilesOption}
                    onClick={this._openUploadPicker}
                  >
                    {__('working-set-specifications.files.upload-new')}
                  </div>
                </div>
              }
            >
              <span className={styles.dropSubtitle}>
                {__('working-set-specifications.files.add-files')}
              </span>
            </Dropdown>
          </ReactDropzone>
        )}
        {/* {!readOnly && (
          <ReactDropzone
            className={classNames(
              styles.dropzone,
              _.get(this.state, 'drag') && styles.drag
            )}
            onDrop={this._handleDrop}
            onDragOver={() => this.setState({ drag: true })}
            onDragLeave={() => this.setState({ drag: false })}
            multiple={true}
          >
            <UploadIcon />
            <span className={styles.dropTitle}>
              {__('dropzone.title.drop-your-file-here')}
            </span>
            <span className={styles.dropSubtitle}>
              {__('dropzone.title.or-select')}
            </span>
          </ReactDropzone>
        )} */}

        {/* Clickboard files */}
        {!_.isEmpty(files) && (
          <Form className={styles.clickboardFiles} onSubmit={this.handleSubmit}>
            {_.map(files, (row, i) => {
              const key = _.toNumber(i);
              return (
                <div className={styles.fileRow} key={key}>
                  <div className={styles.left}>
                    <FilePreview
                      onDownloadFile={this._downloadFile}
                      row={row.file}
                      lightbox_images={lightbox_files}
                    />
                  </div>

                  <div className={styles.right}>
                    <div className={styles.select}>
                      <Select
                        disabled={readOnly}
                        placeholder={__(
                          'specifications.working-set.flyout.select-file-category'
                        )}
                        // label={__(
                        //   'specifications.working-set.flyout.file-category'
                        // )}
                        input={{
                          value:
                            this.state.files && this.state.files[i]?.category
                              ? this.state.files[i].category
                              : '',
                          onChange: (value) => {
                            this.setState({
                              files: {
                                ...this.state.files,
                                [key]: {
                                  ...this.state.files[key],
                                  category: value,
                                },
                              },

                              category_errors: _.filter(
                                category_errors,
                                (error) => error != key
                              ),
                            });
                          },
                          onBlur: () =>
                            this.setState({
                              active_category: { [key]: false },
                            }),
                          onFocus: () =>
                            this.setState({ active_category: { [key]: true } }),
                        }}
                        meta={{
                          active: active_category && active_category[key],
                          error: _.includes(category_errors, key),
                          touched: _.includes(category_errors, key),
                        }}
                        options={
                          !_.includes(
                            ['jpg', 'jpeg', 'png'],
                            _.toLower(row.file.ext)
                          )
                            ? _.filter(
                                categories,
                                (category) =>
                                  !_.includes(
                                    [
                                      'thumbnail',
                                      'product',
                                      'drawing',
                                      'ambient',
                                      'technical',
                                      'tileable',
                                    ],
                                    category.value
                                  )
                              )
                            : categories
                        }
                        top={28}
                        noSort
                        searchable
                      />
                    </div>
                    {!readOnly && (
                      <div className={styles.icons}>
                        <DeleteIcon
                          onClick={() => {
                            this.setState(
                              {
                                files: _.filter(files, (file) => file != row),
                              },
                              () => {
                                this.props.change('files', this.state.files);
                              }
                            );
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
            {!readOnly && (
              <div className={styles.addRow}>
                <button onClick={this._uploadFiles} type='button'>
                  {__('specifications.working-set.flyout.add-files')}
                </button>
              </div>
            )}
          </Form>
        )}
      </div>
    );
  }
}

export default Files;
